// Reconstructed from the supplied production build; original component names were unavailable.
import { React } from "../vendor/runtime.js";
import { authApi } from "../api/auth.js";
const AuthContext = React.createContext();
const useAuth = () => React.useContext(AuthContext);
const AuthProvider = ({ children: a }) => {
  const [n, i] = React.useState(null),
    [l, c] = React.useState(true),
    [u, m] = React.useState(null);
  React.useEffect(() => {
    (async () => {
      try {
        const N = await authApi.getCurrentUser();
        i(N.user);
      } catch {
        console.log("No authenticated user");
      } finally {
        c(false);
      }
    })();
  }, []);
  const y = {
    currentUser: n,
    loading: l,
    error: u,
    login: async (w, N) => {
      try {
        m(null);
        const T = await authApi.login(w, N);
        return (i(T.user), T);
      } catch (T) {
        throw (m(T.message || "Login failed"), T);
      }
    },
    register: async (w, N, T, C) => {
      try {
        return (m(null), await authApi.register(w, N, T, C));
      } catch (A) {
        throw (m(A.message || "Registration failed"), A);
      }
    },
    verifyEmail: async (w, N) => {
      try {
        return (m(null), await authApi.verifyEmail(w, N));
      } catch (T) {
        throw (m(T.message || "Verification failed"), T);
      }
    },
    resendOTP: async (w) => {
      try {
        return (m(null), await authApi.resendOTP(w));
      } catch (N) {
        throw (m(N.message || "Failed to resend verification code"), N);
      }
    },
    logout: async () => {
      try {
        (await authApi.logout(), i(null));
      } catch (w) {
        m(w.message || "Logout failed");
      }
    },
  };
  return <AuthContext.Provider value={y}>{a}</AuthContext.Provider>;
};
export { AuthContext, useAuth, AuthProvider };
